import React, { useEffect, useState, useMemo } from "react";
import {
    getPaymentNewApi,
    getTxnBrreakDownApi,
    getAllPaymentModesApi,
    getAllPaymentChannelApi,
    SaveBulkVerifyPaymentApi,
    getDownlaodPaymentReportByVerififedStatus,
    getPaymentsMarkeRefundedinUnverifiedPayments
} from "../AdminActionCreator.component";
import Pagination from '@mui/material/Pagination';
import Loader from '../../../presentationals/Loader/Loader.component';
import PopUp from "../../../presentationals/Popup/Popup.component";
import EmiBreakUp from "./breakdownpopup";
import moment from "moment";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import DownloadIcon from '@mui/icons-material/Download';
import NodataImage from '../../../../images/nodata.png';

// ─── Bucket config ────────────────────────────────────────────────────────────
const BUCKET_TABS = [
    { key: "overall", label: "Overall", color: "#fa5a7d", bg: "#ffe2e6", icon: "fa-cart-arrow-down" },
    { key: "onTime", label: "On Time", color: "#3dd856", bg: "#dcfce7", icon: "fa-check-circle" },
    { key: "foreclosed", label: "Foreclosed", color: "#267dff", bg: "#dbeafe", icon: "fa-flag-checkered" },
    { key: "unknown", label: "Unknown", color: "#bf83ff", bg: "#f4e8ff", icon: "fa-question-circle" },
    { key: "bucket0To30", label: "0–30 DPD", color: "#ff947a", bg: "#fff4de", icon: "fa-clock-o" },
    { key: "bucket31To60", label: "31–60 DPD", color: "#dbb328", bg: "#fff1c1", icon: "fa-exclamation-circle" },
    { key: "bucket61To90", label: "61–90 DPD", color: "#ea580c", bg: "#ffedd5", icon: "fa-exclamation-triangle" },
    { key: "bucket90Plus", label: "90+ DPD", color: "#dc2626", bg: "#fee2e2", icon: "fa-times-circle" },
    // { key: "penality", label: "Penalty", color: "#4f46e5", bg: "#e0e7ff", icon: "fa-credit-card" },
    // { key: "bounce", label: "Bounce", color: "#f43f5e", bg: "#ffe4e6", icon: "fa-ban" }
];

const fmtINR = (n) => Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtCnt = (n) => Number(n || 0).toLocaleString('en-US');

// ─── CopyableText Component ──────────────────────────────────────────────────
const CopyableText = ({ text }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = (e) => {
        e.stopPropagation();
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    return (
        <span className="copyable-text-wrapper" onClick={handleCopy} title="Click to copy Transaction ID">
            <span className="monospace-text">{text}</span>
            <span className={`copy-icon-container ${copied ? 'copied' : ''}`}>
                {copied ? (
                    <i className="fa fa-check" style={{ color: '#16a34a' }} />
                ) : (
                    <i className="fa fa-clone" />
                )}
            </span>
        </span>
    );
};

// Scoped custom CSS styles
const cssStyles = `
.unverified-payments-dashboard {
  background: #ffffff;
  padding: 24px;
  border-radius: 16px;
//   border: 1px solid #e2e8f0;
  box-shadow: 0 4px 24px rgba(148, 163, 184, 0.06);
  margin-top: 15px;
  margin-bottom: 30px;
}

.unverified-payments-dashboard .dashboard-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 16px;
}

.unverified-payments-dashboard .dashboard-title-area {
  display: flex;
  align-items: center;
  gap: 14px;
}

.unverified-payments-dashboard .dashboard-title-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #0284c7;
}

.unverified-payments-dashboard .dashboard-title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.unverified-payments-dashboard .dashboard-subtitle {
  margin: 2px 0 0 0;
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.unverified-payments-dashboard .filter-card {
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 24px;
}

.unverified-payments-dashboard .filter-card label {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 6px;
  display: block;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.unverified-payments-dashboard .form-control {
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  height: 38px;
  transition: all 0.2s ease;
  box-shadow: none;
}

.unverified-payments-dashboard .form-control:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  background-color: #ffffff;
  outline: none;
}

.unverified-payments-dashboard .download-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border: none;
  color: #ffffff;
  font-weight: 600;
  font-size: 13px;
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
  margin-top: 22px;
  width: 100%;
}

.unverified-payments-dashboard .download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.25);
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}

.unverified-payments-dashboard .download-btn:active {
  transform: translateY(0);
}

.unverified-payments-dashboard .summary-table-container {
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
  margin-bottom: 32px;
  overflow-x: auto;
}

.unverified-payments-dashboard .summary-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  table-layout: fixed;
}

.unverified-payments-dashboard .summary-table th {
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 14px 16px;
  border-bottom: 2px solid #e2e8f0;
}

.unverified-payments-dashboard .summary-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s ease;
  vertical-align: middle;
}

.unverified-payments-dashboard .summary-table tr:hover td {
  background-color: #f8fafc;
}

.unverified-payments-dashboard .summary-table .summary-table-row {
  display: table-row !important;
}

.unverified-payments-dashboard .summary-table tr.row-active td {
  background-color: var(--active-bg-color) !important;
  font-weight: 700;
}

.unverified-payments-dashboard .summary-table tr.row-active td:first-child {
  border-left: 4px solid var(--active-color) !important;
}

.unverified-payments-dashboard .summary-table tr.row-combined td {
  background-color: #eff6ff88 !important;
  font-weight: 700;
}

.unverified-payments-dashboard .summary-table tr.row-combined td:first-child {
  border-left: 4px solid #3b82f6 !important;
}

.unverified-payments-dashboard .summary-table .summary-category-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.unverified-payments-dashboard .summary-table .summary-icon-wrapper {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.unverified-payments-dashboard .summary-table .summary-metric-val-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.unverified-payments-dashboard .summary-table .summary-val {
  font-size: 13px;
  color: #1e293b;
}

.unverified-payments-dashboard .summary-table .summary-cnt-badge {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  background: #e2e8f0;
  padding: 1px 5px;
  border-radius: 6px;
  width: max-content;
}

.unverified-payments-dashboard .summary-table tr.row-active .summary-cnt-badge {
  background: rgba(255, 255, 255, 0.4);
}

.unverified-payments-dashboard .summary-table .summary-viewing-badge {
  background: #10b981;
  color: white;
  font-size: 9px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.15);
  margin-left: auto;
}

.unverified-payments-dashboard .summary-table tr.total-row td {
  background: #f8fafc;
  border-top: 2px solid #e2e8f0;
  border-bottom: none;
  font-weight: 700;
}

.unverified-payments-dashboard .summary-table tr.total-row:hover td {
  background: #f1f5f9;
}

.unverified-payments-dashboard .payments-table-container {
  border-radius: 16px;
  border: 1px solid #e2e8f0;

  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.02);
  margin-bottom: 20px;
}
  .unverified-payments-dashboard .payments-table-container .tablesconf {
 
  overflow-x: auto;

}

.unverified-payments-dashboard table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.unverified-payments-dashboard th {
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 14px 16px;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

.unverified-payments-dashboard td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  vertical-align: middle;
  transition: background-color 0.15s ease;
}

.unverified-payments-dashboard tr:hover td {
  background-color: #f8fafc;
}

.unverified-payments-dashboard tr.row-selected td {
  background-color: #eff6ff !important;
}

.unverified-payments-dashboard tr.row-selected:hover td {
  background-color: #dbeafe !important;
}

.unverified-payments-dashboard .custom-checkbox {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.unverified-payments-dashboard .custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.unverified-payments-dashboard .checkmark {
  position: relative;
  display: inline-block;
  height: 18px;
  width: 18px;
  background-color: #ffffff;
  border: 2px solid #cbd5e1;
  border-radius: 5px;
  transition: all 0.2s ease;
}

.unverified-payments-dashboard .custom-checkbox:hover input ~ .checkmark {
  border-color: #94a3b8;
}

.unverified-payments-dashboard .custom-checkbox input:checked ~ .checkmark {
  background-color: #2563eb;
  border-color: #2563eb;
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
}

.unverified-payments-dashboard .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.unverified-payments-dashboard .custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}

.unverified-payments-dashboard .custom-checkbox .checkmark:after {
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.unverified-payments-dashboard .info-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  cursor: pointer;
  background: #ffffff;
  transition: all 0.2s ease;
}

.unverified-payments-dashboard .info-btn:hover {
  background: #f1f5f9;
  color: #1e293b;
  border-color: #cbd5e1;
  transform: scale(1.05);
}

.unverified-payments-dashboard .copyable-text-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background-color 0.15s ease;
}

.unverified-payments-dashboard .copyable-text-wrapper:hover {
  background-color: #f1f5f9;
}

.unverified-payments-dashboard .monospace-text {
  font-family: 'SFMono-Regular', Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12px;
  font-weight: 500;
  color: #475569;
}

.unverified-payments-dashboard .copy-icon-container {
  opacity: 0;
  font-size: 11px;
  color: #94a3b8;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
}

.unverified-payments-dashboard .copyable-text-wrapper:hover .copy-icon-container {
  opacity: 1;
}

.unverified-payments-dashboard .copy-icon-container.copied {
  opacity: 1;
}

.unverified-payments-dashboard th.sortable-th {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

.unverified-payments-dashboard th.sortable-th:hover {
  background-color: #f1f5f9;
  color: #1e293b;
}

.unverified-payments-dashboard .sort-icon-container {
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  color: #94a3b8;
  vertical-align: middle;
}

.unverified-payments-dashboard .bucket-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 100px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}

.unverified-payments-dashboard .amount-text {
  font-weight: 600;
  color: #334155;
}

.unverified-payments-dashboard .amount-text.overdue {
  color: #dc2626;
  background: #fee2e2;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
}

.unverified-payments-dashboard .pagination-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
  flex-wrap: wrap;
  gap: 12px;
}

.unverified-payments-dashboard .pagination-info {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.unverified-payments-dashboard .verify-action-bar {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.1), 0 4px 12px -2px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  z-index: 1000;
  animation: slideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes slideUp {
  from {
    transform: translate(-50%, 100px);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}

.unverified-payments-dashboard .verify-action-text {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.unverified-payments-dashboard .verify-count-badge {
  background: #3b82f6;
  color: #ffffff;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
}

.unverified-payments-dashboard .verify-btn {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  color: #ffffff;
  border: none;
  padding: 8px 20px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(4, 120, 87, 0.2);
}

.unverified-payments-dashboard .verify-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(4, 120, 87, 0.35);
  background: linear-gradient(135deg, #047857 0%, #065f46 100%);
}

.unverified-payments-dashboard .verify-btn:active {
  transform: translateY(0);
}

.unverified-payments-dashboard .verify-clear-btn {
  background: none;
  border: none;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.unverified-payments-dashboard .verify-clear-btn:hover {
  background: #f1f5f9;
  color: #1e293b;
}

.unverified-payments-dashboard .toast-notification {
  position: fixed;
  top: 24px;
  right: 24px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-left: 4px solid #3b82f6;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 16px -6px rgba(0, 0, 0, 0.05);
  z-index: 10000;
  font-weight: 600;
  font-size: 13px;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 12px;
  animation: slideInRight 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes slideInRight {
  from {
    transform: translateX(120%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.unverified-payments-dashboard .toast-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
  margin-left: auto;
}

.unverified-payments-dashboard .toast-close-btn:hover {
  background: #f1f5f9;
  color: #475569;
}

.unverified-payments-dashboard .empty-state-container {
  padding: 60px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 16px;
  border: 1px dashed #cbd5e1;
  margin-top: 20px;
}

.unverified-payments-dashboard .empty-state-img {
  max-width: 180px;
  opacity: 0.6;
  margin-bottom: 16px;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.01));
}

.unverified-payments-dashboard .empty-state-text {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}
`;

const calculateCategoryStats = (items) => {
    let amt = 0;
    let principal = 0;
    let interest = 0;
    let penalty = 0;
    let penaltyGst = 0;
    let bounce = 0;

    let principalCount = 0;
    let interestCount = 0;
    let penaltyCount = 0;
    let penaltyGstCount = 0;
    let bounceCount = 0;

    if (items && items.length > 0) {
        items.forEach(item => {
            const p = item.payments || item.paymentsDO;
            const bd = item.paymentBreakUpDetailsDO;

            const itemAmt = Number(p?.amount || 0);
            const itemPrincipal = Number(bd?.principalAmount || 0);
            const itemInterest = Number(bd?.interestAmount || 0);
            const itemPenalty = Number(bd?.penalty || 0);
            const itemPenaltyGst = Number(bd?.penaltyGst || 0);
            const itemBounce = Number(bd?.nachBounce || bd?.bounce || 0);

            amt += itemAmt;
            principal += itemPrincipal;
            interest += itemInterest;
            penalty += itemPenalty;
            penaltyGst += itemPenaltyGst;
            bounce += itemBounce;

            if (itemPrincipal > 0) principalCount++;
            if (itemInterest > 0) interestCount++;
            if (itemPenalty > 0) penaltyCount++;
            if (itemPenaltyGst > 0) penaltyGstCount++;
            if (itemBounce > 0) bounceCount++;
        });
    }

    return {
        paymentAmt: amt,
        paymentCount: items?.length || 0,
        paymentPrincipleAmount: principal,
        paymentPrincipleCount: principalCount,
        paymentInterestAmount: interest,
        paymentInterestCount: interestCount,
        paymentPenaltyAmount: penalty,
        paymentPenaltyCount: penaltyCount,
        paymentPenaltyAmountGST: penaltyGst,
        paymentPenaltyCountGST: penaltyGstCount,
        paymentBounceAmount: bounce,
        paymentBounceCount: bounceCount,
    };
};

// ─── Component ────────────────────────────────────────────────────────────────
const AllPaymentsV2 = ({ admin, payload, handlePayload }) => {
    const [startDate, setStartDate] = useState(payload?.startDate ?? "2023-05-28");
    const [endDate, setEndDate] = useState(payload?.endDate ?? "2026-06-11");
    const [applicationId, setApplicationId] = useState('');
    const [processType, setProcessType] = useState('');
    const [mode, setMode] = useState('');

    // Live API States
    const [objectData, setObjectData] = useState([]);
    const [activeBuckets, setActiveBuckets] = useState(["overall"]);
    const activeBucket = useMemo(() => {
        return activeBuckets.includes("overall") 
            ? "overall" 
            : (activeBuckets.includes("penality") ? "penality" : (activeBuckets.includes("bounce") ? "bounce" : "overall"));
    }, [activeBuckets]);
    const [filterDataDsec, setFilterDataDsec] = useState(false);
    const [channelData, setChannelData] = useState([]);
    const [modeData, setModeData] = useState([]);

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 20;

    // Selections
    const [selectedItems, setSelectedItems] = useState([]);
    const [newValues, setNewValues] = useState([]);

    // Popups & Loaders
    const [showData, setShowData] = useState(false);
    const [leadData, setLeadData] = useState('');
    const [payData, setpayData] = useState('');
    const [popupState, setPopupState] = useState(false);
    const [popupStatus, setPopupStatus] = useState('');
    const [loaderState, setLoader] = useState(false);
    const [apiData, setApiData] = useState(null);

    const categories = useMemo(() => BUCKET_TABS.filter(t => t.key !== "overall" && t.key !== "foreclosed"), []);
    const overallTab = useMemo(() => BUCKET_TABS.find(t => t.key === "overall"), []);
    const foreclosedTab = useMemo(() => BUCKET_TABS.find(t => t.key === "foreclosed"), []);

    // sync payload
    useEffect(() => {
        if (handlePayload) {
            handlePayload({
                startDate: startDate ?? "",
                endDate: endDate ?? ""
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, endDate]);

    // Load channels and modes on mount
    useEffect(() => {
        getAllPaymentModesApi((callback) => {
            if (callback && callback?.status === 200 && callback?.message === "success") {
                setModeData(callback?.data || []);
            } else {
                setModeData([]);
            }
        });
        getAllPaymentChannelApi((callback) => {
            if (callback && callback?.status === 200 && callback?.message === "success") {
                setChannelData(callback?.data || []);
            } else {
                setChannelData([]);
            }
        });
    }, []);

    // Fetch payments list when filter parameters change
    useEffect(() => {
        getPaymentFuntion(processType, mode, "overall");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, endDate, processType, mode]);

    const getPaymentFuntion = (channelValue, modeValue, type) => {
        setLoader(true);
        getPaymentNewApi(
            startDate !== '' ? moment(startDate).format('DD-MM-YYYY') : '',
            endDate !== '' ? moment(endDate).format('DD-MM-YYYY') : "",
            false,
            channelValue,
            modeValue,
            type,
            callback => {
                if (callback && callback?.status === 200 && callback?.message === "success") {
                // if (true) {
//                     const ds= {
//     "message": "success",
//     "status": 200,
//     "data": {
//         "overallStats": {
//             "count": 12,
//             "totalPrincipal": 43167.58,
//             "totalInterest": 6393.98,
//             "totalPenalty": 1019.42,
//             "totalPenaltyGst": 183.5,
//             "totalNachBounce": 0.0,
//             "totalBounceGst": 0.0,
//             "totalNachBounceWaived": 0.0,
//             "totalPenaltyWaived": 0.0,
//             "totalEmiAmount": 49858.0,
//             "totalOverdueAmount": 9456.0,
//             "totalPaidAmount": 58971.0,
//             "totalOnTodayAmount": 28648.0
//         },
//         "onTime": {
//             "bucketLabel": "On Time",
//             "stats": {
//                 "count": 5,
//                 "totalPrincipal": 18667.24,
//                 "totalInterest": 2248.76,
//                 "totalPenalty": 0.0,
//                 "totalPenaltyGst": 0.0,
//                 "totalNachBounce": 0.0,
//                 "totalBounceGst": 0.0,
//                 "totalNachBounceWaived": 0.0,
//                 "totalPenaltyWaived": 0.0,
//                 "totalEmiAmount": 20916.0,
//                 "totalOverdueAmount": 0.0,
//                 "totalPaidAmount": 20916.0,
//                 "totalOnTodayAmount": 0.0
//             },
//             "list": [
//                 {
//                     "applicationId": "26010048",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1281,
//                         "emiId": "HIDBkfVjOCAx",
//                         "loanId": "AmUV4NIyWyMvjQWCFpKWcrJmlsM9hPZO",
//                         "principalAmount": 3667.04,
//                         "interestAmount": 650.96,
//                         "rateOfInterest": 0.72,
//                         "penalty": null,
//                         "penaltyGst": null,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 4318.0,
//                         "overdueAmount": null,
//                         "isActive": true,
//                         "updatedBy": "RECONCILIATION",
//                         "createdAt": "06-06-2026",
//                         "updatedAt": "06-06-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "01-04-2026",
//                         "onTodayAmount": null,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_uf6QI3",
//                         "overdueId": null,
//                         "paidAmount": 4318.0
//                     },
//                     "paymentsDO": {
//                         "id": 1281,
//                         "loanId": "AmUV4NIyWyMvjQWCFpKWcrJmlsM9hPZO",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 4318.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SXoDKtEz43McOI",
//                         "pymntMode": "ENACH",
//                         "processType": "FULL",
//                         "dueDate": "2026-04-01 00:00:00",
//                         "addedBy": "RECONCILIATION",
//                         "addedOn": "06-06-2026",
//                         "updatedOn": "06-06-2026",
//                         "refund": false,
//                         "active": true
//                     },
//                     "emiDueDate": "01-04-2026",
//                     "paidDate": "2026-04-01",
//                     "loanStatus": "109",
//                     "daysOverdue": 0,
//                     "bucket": "onTime"
//                 },
//                 {
//                     "applicationId": "26030252",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1298,
//                         "emiId": "ucN50HAmwSqS",
//                         "loanId": "t2ALkCf5yeYeUo9NKmCqTYmAV3ulqR6o",
//                         "principalAmount": 4999.81,
//                         "interestAmount": 562.19,
//                         "rateOfInterest": 0.72,
//                         "penalty": null,
//                         "penaltyGst": null,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 5562.0,
//                         "overdueAmount": null,
//                         "isActive": true,
//                         "updatedBy": "RECONCILIATION",
//                         "createdAt": "06-06-2026",
//                         "updatedAt": "06-06-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "31-03-2026",
//                         "onTodayAmount": null,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_0LOZ7m",
//                         "overdueId": null,
//                         "paidAmount": 5562.0
//                     },
//                     "paymentsDO": {
//                         "id": 1298,
//                         "loanId": "t2ALkCf5yeYeUo9NKmCqTYmAV3ulqR6o",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 5562.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SXPftcNxGlUotZ",
//                         "pymntMode": "ENACH",
//                         "processType": "FULL",
//                         "dueDate": "2026-03-31 00:00:00",
//                         "addedBy": "RECONCILIATION",
//                         "addedOn": "06-06-2026",
//                         "updatedOn": "06-06-2026",
//                         "refund": false,
//                         "active": true
//                     },
//                     "emiDueDate": "31-03-2026",
//                     "paidDate": "2026-03-31",
//                     "loanStatus": "109",
//                     "daysOverdue": 0,
//                     "bucket": "onTime"
//                 },
//                 {
//                     "applicationId": "26030566",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1296,
//                         "emiId": "VoAhngTxwPc3",
//                         "loanId": "dOFTe4nMuiRDAfeYnfASAY8cgGi0a93O",
//                         "principalAmount": 2499.77,
//                         "interestAmount": 271.23,
//                         "rateOfInterest": 0.72,
//                         "penalty": null,
//                         "penaltyGst": null,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 2771.0,
//                         "overdueAmount": null,
//                         "isActive": true,
//                         "updatedBy": "RECONCILIATION",
//                         "createdAt": "06-06-2026",
//                         "updatedAt": "06-06-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "01-04-2026",
//                         "onTodayAmount": null,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_0LOZ7m",
//                         "overdueId": null,
//                         "paidAmount": 2771.0
//                     },
//                     "paymentsDO": {
//                         "id": 1296,
//                         "loanId": "dOFTe4nMuiRDAfeYnfASAY8cgGi0a93O",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 2771.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SXoD4FPYYBuBSh",
//                         "pymntMode": "ENACH",
//                         "processType": "FULL",
//                         "dueDate": "2026-04-01 00:00:00",
//                         "addedBy": "RECONCILIATION",
//                         "addedOn": "06-06-2026",
//                         "updatedOn": "06-06-2026",
//                         "refund": false,
//                         "active": true
//                     },
//                     "emiDueDate": "01-04-2026",
//                     "paidDate": "2026-04-01",
//                     "loanStatus": "109",
//                     "daysOverdue": 0,
//                     "bucket": "onTime"
//                 },
//                 {
//                     "applicationId": "26030629",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1297,
//                         "emiId": "FpqZLufbnIrS",
//                         "loanId": "Nnh27Y6RKAYPqDItqAajVyNhuiTzErIE",
//                         "principalAmount": 5000.26,
//                         "interestAmount": 522.74,
//                         "rateOfInterest": 0.72,
//                         "penalty": null,
//                         "penaltyGst": null,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 5523.0,
//                         "overdueAmount": null,
//                         "isActive": true,
//                         "updatedBy": "RECONCILIATION",
//                         "createdAt": "06-06-2026",
//                         "updatedAt": "06-06-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "01-04-2026",
//                         "onTodayAmount": null,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_0LOZ7m",
//                         "overdueId": null,
//                         "paidAmount": 5523.0
//                     },
//                     "paymentsDO": {
//                         "id": 1297,
//                         "loanId": "Nnh27Y6RKAYPqDItqAajVyNhuiTzErIE",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 5523.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SXoD1f6aI0xcXa",
//                         "pymntMode": "ENACH",
//                         "processType": "FULL",
//                         "dueDate": "2026-04-01 00:00:00",
//                         "addedBy": "RECONCILIATION",
//                         "addedOn": "06-06-2026",
//                         "updatedOn": "06-06-2026",
//                         "refund": false,
//                         "active": true
//                     },
//                     "emiDueDate": "01-04-2026",
//                     "paidDate": "2026-04-01",
//                     "loanStatus": "109",
//                     "daysOverdue": 0,
//                     "bucket": "onTime"
//                 },
//                 {
//                     "applicationId": "26031094",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1300,
//                         "emiId": "AAGThBoD6jAM",
//                         "loanId": "CC9upscsrFs8wvqgpCd9bJtLdhvi3k8x",
//                         "principalAmount": 2500.36,
//                         "interestAmount": 241.64,
//                         "rateOfInterest": 0.72,
//                         "penalty": null,
//                         "penaltyGst": null,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 2742.0,
//                         "overdueAmount": null,
//                         "isActive": true,
//                         "updatedBy": "RECONCILIATION",
//                         "createdAt": "06-06-2026",
//                         "updatedAt": "06-06-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "29-03-2026",
//                         "onTodayAmount": null,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_0LOZ7m",
//                         "overdueId": null,
//                         "paidAmount": 2742.0
//                     },
//                     "paymentsDO": {
//                         "id": 1300,
//                         "loanId": "CC9upscsrFs8wvqgpCd9bJtLdhvi3k8x",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 2742.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SWcbZUCgOl6TXq",
//                         "pymntMode": "ENACH",
//                         "processType": "FULL",
//                         "dueDate": "2026-03-29 00:00:00",
//                         "addedBy": "RECONCILIATION",
//                         "addedOn": "06-06-2026",
//                         "updatedOn": "06-06-2026",
//                         "refund": false,
//                         "active": true
//                     },
//                     "emiDueDate": "29-03-2026",
//                     "paidDate": "2026-03-29",
//                     "loanStatus": "109",
//                     "daysOverdue": 0,
//                     "bucket": "onTime"
//                 }
//             ]
//         },
//         "foreclosed": {
//             "bucketLabel": "Foreclosed",
//             "stats": {
//                 "count": 7,
//                 "totalPrincipal": 24500.34,
//                 "totalInterest": 4145.22,
//                 "totalPenalty": 1019.42,
//                 "totalPenaltyGst": 183.5,
//                 "totalNachBounce": 0.0,
//                 "totalBounceGst": 0.0,
//                 "totalNachBounceWaived": 0.0,
//                 "totalPenaltyWaived": 0.0,
//                 "totalEmiAmount": 28942.0,
//                 "totalOverdueAmount": 9456.0,
//                 "totalPaidAmount": 38055.0,
//                 "totalOnTodayAmount": 28648.0
//             },
//             "list": [
//                 {
//                     "applicationId": "26033557",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1277,
//                         "emiId": "dKhlxIDuVVbv",
//                         "loanId": "H19yhm6jnI4yXEQomCsuuPK1wJGtWi74",
//                         "principalAmount": 2500.53,
//                         "interestAmount": 488.44,
//                         "rateOfInterest": 1.2,
//                         "penalty": null,
//                         "penaltyGst": null,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 3043.0,
//                         "overdueAmount": null,
//                         "isActive": true,
//                         "updatedBy": "foreclosure payment",
//                         "createdAt": "30-05-2026",
//                         "updatedAt": "30-05-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "29-05-2026",
//                         "onTodayAmount": 2989.0,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_DTKGb7",
//                         "overdueId": null,
//                         "paidAmount": 2989.0
//                     },
//                     "paymentsDO": {
//                         "id": 1277,
//                         "loanId": "H19yhm6jnI4yXEQomCsuuPK1wJGtWi74",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 2988.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SgS2ExrMVAXlAO",
//                         "pymntMode": "APP",
//                         "processType": "FORECLOSE",
//                         "dueDate": "2026-05-29 00:00:00",
//                         "addedBy": "Razorpay Order Handler",
//                         "addedOn": "30-05-2026",
//                         "updatedOn": "30-05-2026",
//                         "refund": null,
//                         "active": true
//                     },
//                     "emiDueDate": "29-05-2026",
//                     "paidDate": "2026-04-22",
//                     "loanStatus": "109",
//                     "daysOverdue": -37,
//                     "bucket": "foreclosed"
//                 },
//                 {
//                     "applicationId": "26034785",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1279,
//                         "emiId": "GUwkbtlSHAuh",
//                         "loanId": "sSzh66Wi3tG3nyEo8k9kkJdojX9Ec70l",
//                         "principalAmount": 5000.15,
//                         "interestAmount": 814.87,
//                         "rateOfInterest": 1.08,
//                         "penalty": null,
//                         "penaltyGst": null,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 5947.0,
//                         "overdueAmount": null,
//                         "isActive": true,
//                         "updatedBy": "foreclosure payment",
//                         "createdAt": "30-05-2026",
//                         "updatedAt": "30-05-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "03-06-2026",
//                         "onTodayAmount": 5816.0,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_GVWJdJ",
//                         "overdueId": null,
//                         "paidAmount": 5816.0
//                     },
//                     "paymentsDO": {
//                         "id": 1279,
//                         "loanId": "sSzh66Wi3tG3nyEo8k9kkJdojX9Ec70l",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 5813.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SeopZSxSdYAL4P",
//                         "pymntMode": "APP",
//                         "processType": "FORECLOSE",
//                         "dueDate": "2026-06-03 00:00:00",
//                         "addedBy": "Razorpay Order Handler",
//                         "addedOn": "30-05-2026",
//                         "updatedOn": "30-05-2026",
//                         "refund": null,
//                         "active": true
//                     },
//                     "emiDueDate": "03-06-2026",
//                     "paidDate": "2026-04-18",
//                     "loanStatus": "109",
//                     "daysOverdue": -46,
//                     "bucket": "foreclosed"
//                 },
//                 {
//                     "applicationId": "26042007",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1275,
//                         "emiId": "O86xqwdCYn1O",
//                         "loanId": "yftppuvPG1s5zF2uo676UYhbMM28xW0i",
//                         "principalAmount": 3999.86,
//                         "interestAmount": 710.14,
//                         "rateOfInterest": 1.2,
//                         "penalty": 509.71,
//                         "penaltyGst": 91.75,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 4710.0,
//                         "overdueAmount": 4728.0,
//                         "isActive": true,
//                         "updatedBy": "full payment",
//                         "createdAt": "29-05-2026",
//                         "updatedAt": "29-05-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "03-05-2026",
//                         "onTodayAmount": 4710.0,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_rn9rRQ",
//                         "overdueId": 216,
//                         "paidAmount": 9416.0
//                     },
//                     "paymentsDO": {
//                         "id": 1275,
//                         "loanId": "yftppuvPG1s5zF2uo676UYhbMM28xW0i",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 4708.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SkO5Vqv3Frj43F",
//                         "pymntMode": "APP",
//                         "processType": "FULL",
//                         "dueDate": "2026-05-03 00:00:00",
//                         "addedBy": "Razorpay Order Handler",
//                         "addedOn": "29-05-2026",
//                         "updatedOn": "29-05-2026",
//                         "refund": null,
//                         "active": true
//                     },
//                     "emiDueDate": "03-05-2026",
//                     "paidDate": "2026-05-02",
//                     "loanStatus": "109",
//                     "daysOverdue": -1,
//                     "bucket": "foreclosed"
//                 },
//                 {
//                     "applicationId": "26042007",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1275,
//                         "emiId": "O86xqwdCYn1O",
//                         "loanId": "yftppuvPG1s5zF2uo676UYhbMM28xW0i",
//                         "principalAmount": 3999.86,
//                         "interestAmount": 710.14,
//                         "rateOfInterest": 1.2,
//                         "penalty": 509.71,
//                         "penaltyGst": 91.75,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 4710.0,
//                         "overdueAmount": 4728.0,
//                         "isActive": true,
//                         "updatedBy": "full payment",
//                         "createdAt": "29-05-2026",
//                         "updatedAt": "29-05-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "03-05-2026",
//                         "onTodayAmount": 4710.0,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_rn9rRQ",
//                         "overdueId": 216,
//                         "paidAmount": 9416.0
//                     },
//                     "paymentsDO": {
//                         "id": 1275,
//                         "loanId": "yftppuvPG1s5zF2uo676UYhbMM28xW0i",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 4708.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SkO5Vqv3Frj43F",
//                         "pymntMode": "APP",
//                         "processType": "FULL",
//                         "dueDate": "2026-05-03 00:00:00",
//                         "addedBy": "Razorpay Order Handler",
//                         "addedOn": "29-05-2026",
//                         "updatedOn": "29-05-2026",
//                         "refund": null,
//                         "active": true
//                     },
//                     "emiDueDate": "03-05-2026",
//                     "paidDate": "2026-05-02",
//                     "loanStatus": "109",
//                     "daysOverdue": -1,
//                     "bucket": "foreclosed"
//                 },
//                 {
//                     "applicationId": "26042007",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1276,
//                         "emiId": "eBgOLITR9vb0",
//                         "loanId": "yftppuvPG1s5zF2uo676UYhbMM28xW0i",
//                         "principalAmount": 3999.86,
//                         "interestAmount": 642.78,
//                         "rateOfInterest": 1.2,
//                         "penalty": null,
//                         "penaltyGst": null,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 4710.0,
//                         "overdueAmount": null,
//                         "isActive": true,
//                         "updatedBy": "full payment",
//                         "createdAt": "29-05-2026",
//                         "updatedAt": "29-05-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "03-06-2026",
//                         "onTodayAmount": 4643.0,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_rn9rRQ",
//                         "overdueId": null,
//                         "paidAmount": 4641.0
//                     },
//                     "paymentsDO": {
//                         "id": 1276,
//                         "loanId": "yftppuvPG1s5zF2uo676UYhbMM28xW0i",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 4641.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SlBKD33s6goGh1",
//                         "pymntMode": "APP",
//                         "processType": "FULL",
//                         "dueDate": "2026-06-03 00:00:00",
//                         "addedBy": "Razorpay Order Handler",
//                         "addedOn": "29-05-2026",
//                         "updatedOn": "29-05-2026",
//                         "refund": null,
//                         "active": true
//                     },
//                     "emiDueDate": "03-06-2026",
//                     "paidDate": "2026-05-04",
//                     "loanStatus": "109",
//                     "daysOverdue": -30,
//                     "bucket": "foreclosed"
//                 },
//                 {
//                     "applicationId": "26042437",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1280,
//                         "emiId": "KY7xX2LtlnSq",
//                         "loanId": "a38B7HtsVH6rHHZ2aPoWDbjTRljj65p5",
//                         "principalAmount": 2500.04,
//                         "interestAmount": 406.65,
//                         "rateOfInterest": 1.2,
//                         "penalty": null,
//                         "penaltyGst": null,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 2911.0,
//                         "overdueAmount": null,
//                         "isActive": true,
//                         "updatedBy": "full payment",
//                         "createdAt": "30-05-2026",
//                         "updatedAt": "30-05-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "02-05-2026",
//                         "onTodayAmount": 2907.0,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_DTKGb7",
//                         "overdueId": null,
//                         "paidAmount": 2906.0
//                     },
//                     "paymentsDO": {
//                         "id": 1280,
//                         "loanId": "a38B7HtsVH6rHHZ2aPoWDbjTRljj65p5",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 2906.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SiyL6DBIXW1HjF",
//                         "pymntMode": "APP",
//                         "processType": "FULL",
//                         "dueDate": "2026-05-02 00:00:00",
//                         "addedBy": "Razorpay Order Handler",
//                         "addedOn": "30-05-2026",
//                         "updatedOn": "30-05-2026",
//                         "refund": null,
//                         "active": true
//                     },
//                     "emiDueDate": "02-05-2026",
//                     "paidDate": "2026-04-28",
//                     "loanStatus": "109",
//                     "daysOverdue": -4,
//                     "bucket": "foreclosed"
//                 },
//                 {
//                     "applicationId": "26042437",
//                     "paymentBreakUpDetailsDO": {
//                         "id": 1278,
//                         "emiId": "LOYplQJl5q45",
//                         "loanId": "a38B7HtsVH6rHHZ2aPoWDbjTRljj65p5",
//                         "principalAmount": 2500.04,
//                         "interestAmount": 372.2,
//                         "rateOfInterest": 1.2,
//                         "penalty": null,
//                         "penaltyGst": null,
//                         "nachBounce": null,
//                         "bounceGst": null,
//                         "emiAmount": 2911.0,
//                         "overdueAmount": null,
//                         "isActive": true,
//                         "updatedBy": "full payment",
//                         "createdAt": "30-05-2026",
//                         "updatedAt": "30-05-2026",
//                         "penaltyWaived": 0.0,
//                         "nachBounceWaived": 0.0,
//                         "dueDate": "02-06-2026",
//                         "onTodayAmount": 2873.0,
//                         "isVerified": false,
//                         "verifiedBy": null,
//                         "nbfcId": "ATcUsLVH",
//                         "productId": "prod_DTKGb7",
//                         "overdueId": null,
//                         "paidAmount": 2871.0
//                     },
//                     "paymentsDO": {
//                         "id": 1278,
//                         "loanId": "a38B7HtsVH6rHHZ2aPoWDbjTRljj65p5",
//                         "verifyStatus": null,
//                         "verifier": null,
//                         "amount": 2871.0,
//                         "provider": "RAZORPAY",
//                         "providerTransId": "pay_SljwEpmmVndgDc",
//                         "pymntMode": "APP",
//                         "processType": "FULL",
//                         "dueDate": "2026-06-02 00:00:00",
//                         "addedBy": "Razorpay Order Handler",
//                         "addedOn": "30-05-2026",
//                         "updatedOn": "30-05-2026",
//                         "refund": null,
//                         "active": true
//                     },
//                     "emiDueDate": "02-06-2026",
//                     "paidDate": "2026-05-05",
//                     "loanStatus": "109",
//                     "daysOverdue": -28,
//                     "bucket": "foreclosed"
//                 }
//             ]
//         },
//         "bucket0To30": {
//             "bucketLabel": "Overdue 0-30 DPD",
//             "stats": {
//                 "count": 0,
//                 "totalPrincipal": 0.0,
//                 "totalInterest": 0.0,
//                 "totalPenalty": 0.0,
//                 "totalPenaltyGst": 0.0,
//                 "totalNachBounce": 0.0,
//                 "totalBounceGst": 0.0,
//                 "totalNachBounceWaived": 0.0,
//                 "totalPenaltyWaived": 0.0,
//                 "totalEmiAmount": 0.0,
//                 "totalOverdueAmount": 0.0,
//                 "totalPaidAmount": 0.0,
//                 "totalOnTodayAmount": 0.0
//             },
//             "list": []
//         },
//         "bucket31To60": {
//             "bucketLabel": "Overdue 31-60 DPD",
//             "stats": {
//                 "count": 0,
//                 "totalPrincipal": 0.0,
//                 "totalInterest": 0.0,
//                 "totalPenalty": 0.0,
//                 "totalPenaltyGst": 0.0,
//                 "totalNachBounce": 0.0,
//                 "totalBounceGst": 0.0,
//                 "totalNachBounceWaived": 0.0,
//                 "totalPenaltyWaived": 0.0,
//                 "totalEmiAmount": 0.0,
//                 "totalOverdueAmount": 0.0,
//                 "totalPaidAmount": 0.0,
//                 "totalOnTodayAmount": 0.0
//             },
//             "list": []
//         },
//         "bucket61To90": {
//             "bucketLabel": "Overdue 61-90 DPD",
//             "stats": {
//                 "count": 0,
//                 "totalPrincipal": 0.0,
//                 "totalInterest": 0.0,
//                 "totalPenalty": 0.0,
//                 "totalPenaltyGst": 0.0,
//                 "totalNachBounce": 0.0,
//                 "totalBounceGst": 0.0,
//                 "totalNachBounceWaived": 0.0,
//                 "totalPenaltyWaived": 0.0,
//                 "totalEmiAmount": 0.0,
//                 "totalOverdueAmount": 0.0,
//                 "totalPaidAmount": 0.0,
//                 "totalOnTodayAmount": 0.0
//             },
//             "list": []
//         },
//         "bucket90Plus": {
//             "bucketLabel": "Overdue 90+ DPD",
//             "stats": {
//                 "count": 0,
//                 "totalPrincipal": 0.0,
//                 "totalInterest": 0.0,
//                 "totalPenalty": 0.0,
//                 "totalPenaltyGst": 0.0,
//                 "totalNachBounce": 0.0,
//                 "totalBounceGst": 0.0,
//                 "totalNachBounceWaived": 0.0,
//                 "totalPenaltyWaived": 0.0,
//                 "totalEmiAmount": 0.0,
//                 "totalOverdueAmount": 0.0,
//                 "totalPaidAmount": 0.0,
//                 "totalOnTodayAmount": 0.0
//             },
//             "list": []
//         },
//         "unknown": {
//             "bucketLabel": "Unknown",
//             "stats": {
//                 "count": 0,
//                 "totalPrincipal": 0.0,
//                 "totalInterest": 0.0,
//                 "totalPenalty": 0.0,
//                 "totalPenaltyGst": 0.0,
//                 "totalNachBounce": 0.0,
//                 "totalBounceGst": 0.0,
//                 "totalNachBounceWaived": 0.0,
//                 "totalPenaltyWaived": 0.0,
//                 "totalEmiAmount": 0.0,
//                 "totalOverdueAmount": 0.0,
//                 "totalPaidAmount": 0.0,
//                 "totalOnTodayAmount": 0.0
//             },
//             "list": []
//         }
//     },
//     "error": null
// }
                    const data = callback?.data;
                    // const data = ds?.data;
                    setApiData(data || null);

                    // Extract and combine the list of payments across all DPD buckets
                    const combined = [];
                    const buckets = ["onTime", "foreclosed", "bucket0To30", "bucket31To60", "bucket61To90", "bucket90Plus", "unknown"];
                    buckets.forEach(bKey => {
                        const bucketObj = data?.[bKey];
                        if (bucketObj && bucketObj.list && bucketObj.list.length > 0) {
                            // Ensure bucket property is set on list items
                            bucketObj.list.forEach(item => {
                                item.bucket = bKey;
                            });
                            combined.push(...bucketObj.list);
                        }
                    });
                    setObjectData(combined);
                } else {
                    setApiData(null);
                    setObjectData([]);
                }
                setLoader(false);
            }
        );
    };

    // ── Client-side DPD Bucket Mapping ──────────────────────────────────────────
    const getItemBucket = (item) => {
        if (item?.bucket) return item.bucket;
        const p = item?.payments || item?.paymentsDO;
        if (p?.processType === "FORECLOSE") return "foreclosed";

        const days = Number(item?.daysOverdue);
        if (isNaN(days) || days === 0) return "onTime";
        if (days > 0 && days <= 30) return "bucket0To30";
        if (days > 30 && days <= 60) return "bucket31To60";
        if (days > 60 && days <= 90) return "bucket61To90";
        if (days > 90) return "bucket90Plus";
        return "unknown";
    };

    const mapServerStats = (serverStats, list = []) => {
        if (!serverStats) {
            return {
                paymentAmt: 0,
                paymentCount: 0,
                paymentPrincipleAmount: 0,
                paymentPrincipleCount: 0,
                paymentInterestAmount: 0,
                paymentInterestCount: 0,
                paymentPenaltyAmount: 0,
                paymentPenaltyCount: 0,
                paymentPenaltyAmountGST: 0,
                paymentPenaltyCountGST: 0,
                paymentBounceAmount: 0,
                paymentBounceCount: 0,
            };
        }

        let principalCount = 0;
        let interestCount = 0;
        let penaltyCount = 0;
        let penaltyGstCount = 0;
        let bounceCount = 0;

        if (list && list.length > 0) {
            list.forEach(item => {
                const bd = item.paymentBreakUpDetailsDO;
                if (Number(bd?.principalAmount || 0) > 0) principalCount++;
                if (Number(bd?.interestAmount || 0) > 0) interestCount++;
                if (Number(bd?.penalty || 0) > 0) penaltyCount++;
                if (Number(bd?.penaltyGst || 0) > 0) penaltyGstCount++;
                if (Number(bd?.nachBounce || bd?.bounce || 0) > 0) bounceCount++;
            });
        } else {
            principalCount = serverStats.count || 0;
            interestCount = serverStats.count || 0;
            penaltyCount = serverStats.totalPenalty > 0 ? serverStats.count : 0;
            penaltyGstCount = serverStats.totalPenaltyGst > 0 ? serverStats.count : 0;
            bounceCount = serverStats.totalNachBounce > 0 ? serverStats.count : 0;
        }

        return {
            paymentAmt: Number(serverStats.totalPaidAmount || serverStats.paymentAmt || 0),
            paymentCount: Number(serverStats.count || serverStats.paymentCount || 0),
            paymentPrincipleAmount: Number(serverStats.totalPrincipal || serverStats.paymentPrincipleAmount || 0),
            paymentPrincipleCount: principalCount,
            paymentInterestAmount: Number(serverStats.totalInterest || serverStats.paymentInterestAmount || 0),
            paymentInterestCount: interestCount,
            paymentPenaltyAmount: Number(serverStats.totalPenalty || serverStats.paymentPenaltyAmount || 0),
            paymentPenaltyCount: penaltyCount,
            paymentPenaltyAmountGST: Number(serverStats.totalPenaltyGst || serverStats.paymentPenaltyAmountGST || 0),
            paymentPenaltyCountGST: penaltyGstCount,
            paymentBounceAmount: Number(serverStats.totalNachBounce || serverStats.paymentBounceAmount || 0),
            paymentBounceCount: bounceCount,
        };
    };

    // Compute display statistics dynamically from server stats
    const displayStats = useMemo(() => {
        const defaultCategoryStats = {
            paymentAmt: 0,
            paymentCount: 0,
            paymentPrincipleAmount: 0,
            paymentPrincipleCount: 0,
            paymentInterestAmount: 0,
            paymentInterestCount: 0,
            paymentPenaltyAmount: 0,
            paymentPenaltyCount: 0,
            paymentPenaltyAmountGST: 0,
            paymentPenaltyCountGST: 0,
            paymentBounceAmount: 0,
            paymentBounceCount: 0,
        };

        const defaultStats = {
            overall: defaultCategoryStats,
            onTime: defaultCategoryStats,
            foreclosed: defaultCategoryStats,
            bucket0To30: defaultCategoryStats,
            bucket31To60: defaultCategoryStats,
            bucket61To90: defaultCategoryStats,
            bucket90Plus: defaultCategoryStats,
            unknown: defaultCategoryStats,
            penality: defaultCategoryStats,
            bounce: defaultCategoryStats,
        };

        if (!apiData) return defaultStats;

        const combined = objectData || [];

        const stats = {
            overall: mapServerStats(apiData.overallStats, combined),
            onTime: mapServerStats(apiData.onTime?.stats, apiData.onTime?.list),
            foreclosed: mapServerStats(apiData.foreclosed?.stats, apiData.foreclosed?.list),
            bucket0To30: mapServerStats(apiData.bucket0To30?.stats, apiData.bucket0To30?.list),
            bucket31To60: mapServerStats(apiData.bucket31To60?.stats, apiData.bucket31To60?.list),
            bucket61To90: mapServerStats(apiData.bucket61To90?.stats, apiData.bucket61To90?.list),
            bucket90Plus: mapServerStats(apiData.bucket90Plus?.stats, apiData.bucket90Plus?.list),
            unknown: mapServerStats(apiData.unknown?.stats, apiData.unknown?.list),
        };

        // Compute Penalty from combined list
        const penaltyList = combined.filter(item => Number(item.paymentBreakUpDetailsDO?.penalty || 0) > 0);
        stats.penality = calculateCategoryStats(penaltyList);
        stats.penality.paymentAmt = Number(apiData.overallStats?.totalPenalty || 0);

        // Compute Bounce from combined list
        const bounceList = combined.filter(item => Number(item.paymentBreakUpDetailsDO?.nachBounce || item.paymentBreakUpDetailsDO?.bounce || 0) > 0);
        stats.bounce = calculateCategoryStats(bounceList);
        stats.bounce.paymentAmt = Number(apiData.overallStats?.totalNachBounce || 0);

        return stats;
    }, [apiData, objectData]);

    // Derived list filter & sort
    // Derived overall statistics from server stats
    const overallStats = useMemo(() => {
        if (!displayStats) {
            return {
                paymentAmt: 0,
                paymentCount: 0,
                paymentPrincipleAmount: 0,
                paymentPrincipleCount: 0,
                paymentInterestAmount: 0,
                paymentInterestCount: 0,
                paymentPenaltyAmount: 0,
                paymentPenaltyCount: 0,
                paymentPenaltyAmountGST: 0,
                paymentPenaltyCountGST: 0,
                paymentBounceAmount: 0,
                paymentBounceCount: 0,
            };
        }
        if (activeBuckets.includes("overall")) {
            return displayStats.overall;
        }

        const sum = {
            paymentAmt: 0,
            paymentCount: 0,
            paymentPrincipleAmount: 0,
            paymentPrincipleCount: 0,
            paymentInterestAmount: 0,
            paymentInterestCount: 0,
            paymentPenaltyAmount: 0,
            paymentPenaltyCount: 0,
            paymentPenaltyAmountGST: 0,
            paymentPenaltyCountGST: 0,
            paymentBounceAmount: 0,
            paymentBounceCount: 0,
        };

        activeBuckets.forEach(key => {
            if (key === "foreclosed" && activeBuckets.length > 1) return; // do not add in any other when multi select row
            const stats = displayStats[key];
            if (stats) {
                sum.paymentAmt += Number(stats.paymentAmt || 0);
                sum.paymentCount += Number(stats.paymentCount || 0);
                sum.paymentPrincipleAmount += Number(stats.paymentPrincipleAmount || 0);
                sum.paymentPrincipleCount += Number(stats.paymentPrincipleCount || 0);
                sum.paymentInterestAmount += Number(stats.paymentInterestAmount || 0);
                sum.paymentInterestCount += Number(stats.paymentInterestCount || 0);
                sum.paymentPenaltyAmount += Number(stats.paymentPenaltyAmount || 0);
                sum.paymentPenaltyCount += Number(stats.paymentPenaltyCount || 0);
                sum.paymentPenaltyAmountGST += Number(stats.paymentPenaltyAmountGST || 0);
                sum.paymentPenaltyCountGST += Number(stats.paymentPenaltyCountGST || 0);
                sum.paymentBounceAmount += Number(stats.paymentBounceAmount || 0);
                sum.paymentBounceCount += Number(stats.paymentBounceCount || 0);
            }
        });

        return sum;
    }, [displayStats, activeBuckets]);

    const activeLabelAndColor = useMemo(() => {
        if (activeBuckets.includes("overall")) {
            const overallTab = BUCKET_TABS.find(t => t.key === "overall");
            return { label: "Overall", color: overallTab?.color || "#fa5a7d" };
        }
        if (activeBuckets.length === 1) {
            const tab = BUCKET_TABS.find(t => t.key === activeBuckets[0]);
            return { label: tab?.label || "Overall", color: tab?.color || "#fa5a7d" };
        }
        const labels = activeBuckets
            .map(k => BUCKET_TABS.find(t => t.key === k)?.label)
            .filter(Boolean);
        return { label: labels.join(" + "), color: "#3b82f6" };
    }, [activeBuckets]);

    // Derived list filter & sort
    const rawList = useMemo(() => {
        if (!objectData) return [];

        if (activeBuckets.includes("overall")) {
            return objectData;
        }

        return objectData.filter(item => {
            const bucketKey = getItemBucket(item);
            if (activeBuckets.includes(bucketKey)) {
                return true;
            }
            if (activeBuckets.includes("penality") && Number(item.paymentBreakUpDetailsDO?.penalty || 0) > 0) {
                return true;
            }
            if (activeBuckets.includes("bounce") && Number(item.paymentBreakUpDetailsDO?.nachBounce || item.paymentBreakUpDetailsDO?.bounce || 0) > 0) {
                return true;
            }
            return false;
        });
    }, [objectData, activeBuckets]);

    const sortedList = useMemo(() => {
        const copy = [...rawList];
        copy.sort((a, b) => {
            const pa = a.payments || a.paymentsDO;
            const pb = b.payments || b.paymentsDO;
            const da = pa?.addedOn || '';
            const db = pb?.addedOn || '';
            return filterDataDsec ? db.localeCompare(da) : da.localeCompare(db);
        });
        return copy;
    }, [rawList, filterDataDsec]);

    const filteredList = useMemo(() => {
        if (!applicationId.trim()) return sortedList;
        return sortedList.filter(i => i.applicationId?.includes(applicationId.trim()));
    }, [sortedList, applicationId]);

    const totalPages = Math.ceil(filteredList.length / ITEMS_PER_PAGE);
    const pagedItems = filteredList.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);



    // Bucket Badge Color
    const bucketBadge = {
        onTime: { color: "#16a34a", bg: "#dcfce7", label: "On Time" },
        foreclosed: { color: "#0891b2", bg: "#cffafe", label: "Foreclosed" },
        bucket0To30: { color: "#d97706", bg: "#fef3c7", label: "0–30 DPD" },
        bucket31To60: { color: "#ea580c", bg: "#ffedd5", label: "31–60 DPD" },
        bucket61To90: { color: "#dc2626", bg: "#fee2e2", label: "61–90 DPD" },
        bucket90Plus: { color: "#9f1239", bg: "#ffe4e6", label: "90+ DPD" },
        unknown: { color: "#6b7280", bg: "#f3f4f6", label: "Unknown" },
    };

    const handlePageChange = (_, val) => {
        setCurrentPage(val);
        setSelectedItems([]);
        setNewValues([]);
    };

    const handleCheckbox = (e, data) => {
        const id = data?.paymentBreakUpDetailsDO?.id;
        if (e.target.checked) {
            setSelectedItems(p => [...p, id]);
            setNewValues(p => [...p, data?.paymentBreakUpDetailsDO]);
        } else {
            setSelectedItems(p => p.filter(i => i !== id));
            setNewValues(p => p.filter(i => i?.id !== id));
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedItems(pagedItems.map(d => d?.paymentBreakUpDetailsDO?.id));
            setNewValues(pagedItems.map(d => d?.paymentBreakUpDetailsDO));
        } else {
            setSelectedItems([]);
            setNewValues([]);
        }
    };

    const switchBucket = (key) => {
        if (key === "overall") {
            setActiveBuckets(["overall"]);
        } else if (key === "foreclosed") {
            setActiveBuckets(prev => {
                if (prev.includes("foreclosed")) {
                    return ["overall"];
                }
                return ["foreclosed"];
            });
        } else {
            setActiveBuckets(prev => {
                if (prev.includes("overall")) {
                    return [key];
                }
                let next = prev.filter(k => k !== "foreclosed");
                if (next.includes(key)) {
                    next = next.filter(k => k !== key);
                } else {
                    next = [...next, key];
                }
                if (next.length === 0) {
                    return ["overall"];
                }
                return next;
            });
        }
        setCurrentPage(1);
        setSelectedItems([]);
        setNewValues([]);
        setApplicationId('');
    };

    // ── Details API Handler ─────────────────────────────────────────────────────
    const detailspayment = (data) => {
        setLeadData(data);
        setLoader(true);
        const p = data?.payments || data?.paymentsDO;
        getTxnBrreakDownApi(p?.providerTransId, p?.loanId, callback => {
            if (callback && callback?.message === "success" && callback?.status === 200) {
                setpayData(callback?.data);
                setShowData(true);
                setLoader(false);
            } else {
                setPopupState(true);
                setPopupStatus("Error fetching payment breakdown!");
                setLoader(false);
                removePopup();
            }
        });
    };

    // ── Refund API Handler ──────────────────────────────────────────────────────
    const handleRefundCheckbox = (e, data) => {
        setLoader(true);
        const p = data?.payments || data?.paymentsDO;
        getPaymentsMarkeRefundedinUnverifiedPayments(p?.loanId, p?.providerTransId, callback => {
            setLoader(false);
            const apiType = ["overall", "penality", "bounce"].includes(activeBucket) ? activeBucket : "overall";
            getPaymentFuntion(processType, mode, apiType);

            if (callback === "Payment marked as refunded successfully.") {
                setPopupState(true);
                setPopupStatus("Status Marked Successfully");
            } else {
                setPopupState(true);
                setPopupStatus(callback || "Error Marking Status");
            }
            setTimeout(() => {
                closePopup();
            }, 5000);
        });
    };

    // ── Verification API Handler ────────────────────────────────────────────────
    const handleVerifyPayments = () => {
        setLoader(true);
        SaveBulkVerifyPaymentApi(admin.emailId, newValues, (callback) => {
            setLoader(false);
            if (callback && callback?.status === 200 && callback?.message === "success") {
                setPopupState(true);
                setPopupStatus("Data Verified Successfully");
                setSelectedItems([]);
                setNewValues([]);
                const apiType = ["overall", "penality", "bounce"].includes(activeBucket) ? activeBucket : "overall";
                getPaymentFuntion(processType, mode, apiType);
            } else {
                setPopupState(true);
                setPopupStatus("Error: Please Try Again later!");
            }
        });
    };

    // ── Download Report API Handler ─────────────────────────────────────────────
    const handleDownload = () => {
        setLoader(true);
        getDownlaodPaymentReportByVerififedStatus(
            moment(startDate).format('DD-MM-YYYY'),
            moment(endDate).format('DD-MM-YYYY'),
            processType,
            mode,
            (callback) => {
                setLoader(false);
            }
        );
    };

    // Filter Dropdowns handlers
    const handleChannelMode = (value, type) => {
        const apiType = ["overall", "penality", "bounce"].includes(activeBucket) ? activeBucket : "overall";
        if (type === "channel") {
            setProcessType(value);
            getPaymentFuntion(value, mode, apiType);
        } else if (type === "mode") {
            setMode(value);
            getPaymentFuntion(processType, value, apiType);
        }
    };

    const removePopup = () => {
        setTimeout(() => {
            setPopupState(false);
        }, 5000);
    };

    const closePopup = () => {
        setShowData(false);
        setPopupState(false);
    };

    // ─────────────────────────────────────────────────────────────────────────────
    return (
        <div className="container-fluid unverified-payments-dashboard" style={{ fontFamily: "inherit" }}>
            <style dangerouslySetInnerHTML={{ __html: cssStyles }} />

            {loaderState && <Loader />}

            {showData && (
                <EmiBreakUp
                    leadData={leadData}
                    payData={payData}
                    close={closePopup}
                    admin={admin}
                    editable={true}
                />
            )}

            {popupState && (
                <PopUp closePopup={closePopup} popupStatus={popupStatus} />
            )}

            {/* ── Title ─────────────────────────────────────────────────────────── */}
            <div className="dashboard-header-container">
                <div className="dashboard-title-area">
                    <div className="dashboard-title-icon"><i className="fa fa-university" /></div>
                    <div>
                        <h3 className="dashboard-title">Unverified Payments</h3>
                        <p className="dashboard-subtitle">Manage, review, and verify pending customer repayments</p>
                    </div>
                </div>
            </div>

            {/* ── Filters ──────────────────────────────── */}
            <div className="filter-card">
                <div className="row">
                    <div className="col-sm-2 col-xs-12">
                        <label>Start Date</label>
                        <input type="date" className="form-control" value={startDate} onChange={e => setStartDate(e.target.value)} />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label>End Date</label>
                        <input type="date" className="form-control" value={endDate} onChange={e => setEndDate(e.target.value)} />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label>Application Id</label>
                        <input type="text" className="form-control" value={applicationId} placeholder="Search…" onChange={e => { setApplicationId(e.target.value); setCurrentPage(1); }} />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label>Channel</label>
                        <select value={processType} onChange={e => handleChannelMode(e.target.value, "channel")} className="form-control">
                            <option value="">All</option>
                            {channelData && channelData.length > 0 ? channelData.map((ch, idx) => (
                                <option key={idx} value={ch}>{ch}</option>
                            )) : null}
                        </select>
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label>Mode</label>
                        <select value={mode} onChange={e => handleChannelMode(e.target.value, "mode")} className="form-control">
                            <option value="">All</option>
                            {modeData && modeData.length > 0 ? modeData.map((md, idx) => (
                                <option key={idx} value={md}>{md}</option>
                            )) : null}
                        </select>
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <button className="download-btn" onClick={handleDownload}>
                            <DownloadIcon style={{ fontSize: 18 }} /> Download Report
                        </button>
                    </div>
                </div>
            </div>

            {/* ── Summary Table (Unified Selector) ── */}
            <div className="summary-table-container">
                <table className="summary-table" >
                    <thead>
                        <tr>
                            <th style={{ width: '22%', minWidth: '180px' }}>Category</th>
                            <th className="text-center" style={{ width: '13%' }}>Total Amount</th>
                            <th className="text-center" style={{ width: '13%' }}>Principal</th>
                            <th className="text-center" style={{ width: '13%' }}>Interest</th>
                            <th className="text-center" style={{ width: '13%' }}>Penalty</th>
                            <th className="text-center" style={{ width: '13%' }}>Penalty GST</th>
                            <th className="text-center" style={{ width: '13%' }}>Bounce</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categories.map((card, ci) => {
                            const stats = displayStats[card.key] || {
                                paymentAmt: 0,
                                paymentCount: 0,
                                paymentPrincipleAmount: 0,
                                paymentPrincipleCount: 0,
                                paymentInterestAmount: 0,
                                paymentInterestCount: 0,
                                paymentPenaltyAmount: 0,
                                paymentPenaltyCount: 0,
                                paymentPenaltyAmountGST: 0,
                                paymentPenaltyCountGST: 0,
                                paymentBounceAmount: 0,
                                paymentBounceCount: 0,
                            };
                            const isActive = activeBuckets.includes(card.key);

                            return (
                                <tr 
                                    key={ci}
                                    className={`summary-table-row ${isActive ? 'row-active' : ''}`}
                                    style={isActive ? {
                                        '--active-color': card.color,
                                        '--active-bg-color': `${card.bg}55`
                                    } : {}}
                                    onClick={() => switchBucket(card.key)}
                                >
                                    <td style={{ width: '22%', minWidth: '180px' }}>
                                        <div className="summary-category-cell">
                                            <div className="summary-icon-wrapper" style={{ backgroundColor: card.color }}>
                                                <i className={`fa ${card.icon}`} aria-hidden="true"></i>
                                            </div>
                                            <span style={{ color: isActive ? card.color : '#1e293b', fontWeight: isActive ? '700' : '600' }}>{card.label}</span>
                                            <span className="summary-cnt-badge">{fmtCnt(stats.paymentCount)} txns</span>
                                            {isActive && (
                                                <span className="summary-viewing-badge">
                                                    <i className="fa fa-check" aria-hidden="true" /> Viewing
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    
                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentAmt)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentPrincipleAmount)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentInterestAmount)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentPenaltyAmount)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentPenaltyAmountGST)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentBounceAmount)}</span>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                        {overallTab && (() => {
                            const card = overallTab;
                            const stats = overallStats;
                            const isActive = activeBuckets.includes(card.key);
                            const isCombined = !activeBuckets.includes("overall") && activeBuckets.length > 1;

                            return (
                                <tr 
                                    className={`summary-table-row total-row ${isActive ? 'row-active' : ''} ${isCombined ? 'row-combined' : ''}`}
                                    style={isActive ? {
                                        '--active-color': card.color,
                                        '--active-bg-color': `${card.bg}55`
                                    } : isCombined ? {
                                        '--active-color': '#3b82f6',
                                        '--active-bg-color': '#eff6ff55'
                                    } : {}}
                                    onClick={() => switchBucket(card.key)}
                                >
                                    <td style={{ width: '22%', minWidth: '180px' }}>
                                        <div className="summary-category-cell">
                                            <div className="summary-icon-wrapper" style={{ backgroundColor: card.color }}>
                                                <i className={`fa ${card.icon}`} aria-hidden="true"></i>
                                            </div>
                                            <span style={{ color: isActive ? card.color : '#1e293b', fontWeight: '700' }}>{card.label}</span>
                                            <span className="summary-cnt-badge">{fmtCnt(stats.paymentCount)} txns</span>
                                            {isActive && (
                                                <span className="summary-viewing-badge">
                                                    <i className="fa fa-check" aria-hidden="true" /> Viewing
                                                </span>
                                            )}
                                            {isCombined && (
                                                <span className="summary-viewing-badge" style={{ backgroundColor: '#3b82f6' }}>
                                                    Combined Total
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    
                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.paymentAmt)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.paymentPrincipleAmount)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.paymentInterestAmount)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.paymentPenaltyAmount)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.paymentPenaltyAmountGST)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.paymentBounceAmount)}</span>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })()}
                        {foreclosedTab && (() => {
                            const card = foreclosedTab;
                            const stats = displayStats[card.key] || {
                                paymentAmt: 0,
                                paymentCount: 0,
                                paymentPrincipleAmount: 0,
                                paymentPrincipleCount: 0,
                                paymentInterestAmount: 0,
                                paymentInterestCount: 0,
                                paymentPenaltyAmount: 0,
                                paymentPenaltyCount: 0,
                                paymentPenaltyAmountGST: 0,
                                paymentPenaltyCountGST: 0,
                                paymentBounceAmount: 0,
                                paymentBounceCount: 0,
                            };
                            const isActive = activeBuckets.includes(card.key);

                            return (
                                <tr 
                                    key="foreclosed-row"
                                    className={`summary-table-row ${isActive ? 'row-active' : ''}`}
                                    style={isActive ? {
                                        '--active-color': card.color,
                                        '--active-bg-color': `${card.bg}55`
                                    } : {}}
                                    onClick={() => switchBucket(card.key)}
                                >
                                    <td style={{ width: '22%', minWidth: '180px' }}>
                                        <div className="summary-category-cell">
                                            <div className="summary-icon-wrapper" style={{ backgroundColor: card.color }}>
                                                <i className={`fa ${card.icon}`} aria-hidden="true"></i>
                                            </div>
                                            <span style={{ color: isActive ? card.color : '#1e293b', fontWeight: isActive ? '700' : '600' }}>{card.label}</span>
                                            <span className="summary-cnt-badge">{fmtCnt(stats.paymentCount)} txns</span>
                                            {isActive && (
                                                <span className="summary-viewing-badge">
                                                    <i className="fa fa-check" aria-hidden="true" /> Viewing
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    
                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentAmt)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentPrincipleAmount)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentInterestAmount)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentPenaltyAmount)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentPenaltyAmountGST)}</span>
                                        </div>
                                    </td>

                                    <td className="text-center" style={{ width: '13%' }}>
                                        <div className="summary-metric-val-row">
                                            <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.paymentBounceAmount)}</span>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })()}
                    </tbody>
                </table>
            </div>

            {/* ── List Title ────────────────────────── */}
            <div className="table-list-title-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', marginTop: '16px' }}>
                <h4 style={{ margin: 0, fontWeight: 700, color: '#1e293b', fontSize: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ width: '4px', height: '16px', background: activeLabelAndColor.color, borderRadius: '2px', display: 'inline-block' }}></span>
                    {activeLabelAndColor.label} Payments List
                </h4>
                {filteredList.length > 0 && (
                    <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 600, background: '#f8fafc', border: '1px solid #e2e8f0', padding: '4px 12px', borderRadius: '20px' }}>
                        {filteredList.length} Records Found
                    </span>
                )}
            </div>

            {/* ── Table ─────────────────────────────────────────────────────────── */}
            {filteredList.length > 0 ? (
                <div className="payments-table-container">
                    <div className="tablesconf">
                        <table>
                            <thead>
                                <tr>
                                    <th className="text-center" style={{ width: 40 }}>
                                        <label className="custom-checkbox">
                                            <input type="checkbox" onChange={handleSelectAll}
                                                checked={pagedItems.length > 0 && pagedItems.every(d => selectedItems.includes(d?.paymentBreakUpDetailsDO?.id))} />
                                            <span className="checkmark"></span>
                                        </label>
                                    </th>
                                    <th className="text-center" style={{ width: 60 }}>Details</th>
                                    <th className="text-center" style={{ width: 80 }}>Refunded</th>
                                    <th className="text-center">Application Id</th>
                            <th className="text-center">Transaction Id</th>
                                    <th className="text-center">Transaction Amount</th>
                                    <th className="text-center">EMI Amount</th>
                                    <th className="text-center">Overdue Amount</th>
                                    <th className="text-center">OnToday Amount</th>
                                    {(activeBuckets.includes("overall") || activeBuckets.length > 1) && <th className="text-center">Bucket</th>}
                                    <th className="text-center">Mode</th>
                                    <th className="text-center">Channel</th>
                                    <th className="text-center">Process Type</th>
                                    <th className="text-center sortable-th" onClick={() => setFilterDataDsec(p => !p)} style={{ width: 140 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            Added On
                                            <span className="sort-icon-container">
                                                {!filterDataDsec
                                                    ? <ArrowDropUpIcon style={{ fontSize: 18 }} />
                                                    : <ArrowDropDownIcon style={{ fontSize: 18 }} />}
                                            </span>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {pagedItems.map((data, idx) => {
                                    const isSelected = selectedItems.includes(data?.paymentBreakUpDetailsDO?.id);
                                    const bk = getItemBucket(data);
                                    const badge = bucketBadge[bk] || bucketBadge.unknown;
                                    const pObj = data?.payments || data?.paymentsDO;
                                    return (
                                        <tr key={idx} className={isSelected ? 'row-selected' : ''}>
                                            <td className="text-center">
                                                <label className="custom-checkbox">
                                                    <input type="checkbox" checked={isSelected} onChange={e => handleCheckbox(e, data)} />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </td>
                                            <td className="text-center">
                                                <button className="info-btn" onClick={() => detailspayment(data)} title="View Details">
                                                    <i className="fa fa-info" />
                                                </button>
                                            </td>
                                            <td className="text-center">
                                                <label className="custom-checkbox" style={{ opacity: pObj?.refund === true ? 0.7 : 1 }}>
                                                    <input type="checkbox" checked={pObj?.refund === true} disabled={pObj?.refund === true} onChange={(e) => handleRefundCheckbox(e, data)} />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </td>
                                            <td className="text-center" style={{ fontWeight: 600 }}>{data?.applicationId}</td>
                                            <td className="text-center">
                                                <CopyableText text={pObj?.providerTransId} />
                                            </td>
                                            <td className="text-center amount-text">₹ {fmtINR(pObj?.amount)}</td>
                                            <td className="text-center amount-text">₹ {fmtINR(data?.paymentBreakUpDetailsDO?.emiAmount)}</td>
                                            <td className="text-center">
                                                <span className={`amount-text ${(data?.paymentBreakUpDetailsDO?.overdueAmount || 0) > 0 ? 'overdue' : ''}`}>
                                                    ₹ {fmtINR(data?.paymentBreakUpDetailsDO?.overdueAmount)}
                                                </span>
                                            </td>
                                            <td className="text-center amount-text">₹ {fmtINR(data?.paymentBreakUpDetailsDO?.onTodayAmount)}</td>
                                            {(activeBuckets.includes("overall") || activeBuckets.length > 1) && (
                                                <td className="text-center">
                                                    <span className="bucket-badge" style={{ background: badge.bg, color: badge.color }}>
                                                        {badge.label}
                                                    </span>
                                                </td>
                                            )}
                                            <td className="text-center"><span style={{ fontWeight: 600, color: '#475569' }}>{pObj?.pymntMode}</span></td>
                                            <td className="text-center" style={{ fontSize: '12px', color: '#64748b' }}>{pObj?.addedBy}</td>
                                            <td className="text-center"><span style={{ background: '#f1f5f9', color: '#475569', padding: '3px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: 600 }}>{pObj?.processType}</span></td>
                                            <td className="text-center" style={{ color: '#64748b', fontSize: '12px' }}>{pObj?.addedOn}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    {/* pagination row */}
                    <div className="pagination-bar">
                        <span className="pagination-info" style={{ paddingLeft: '10px' }}>
                            Showing {filteredList.length === 0 ? 0 : (currentPage - 1) * ITEMS_PER_PAGE + 1}–{Math.min(currentPage * ITEMS_PER_PAGE, filteredList.length)} of {filteredList.length}
                        </span>
                        <Pagination count={totalPages} page={currentPage} onChange={handlePageChange} color="success" />
                    </div>
                </div>
            ) : (
                <div className="empty-state-container">
                    <img alt="no data" src={NodataImage} className="empty-state-img" />
                    <p className="empty-state-text">No records in this category</p>
                </div>
            )}

            {/* Sticky Bottom Actions Bar */}
            {newValues.length > 0 && (
                <div className="verify-action-bar">
                    <span className="verify-action-text">
                        <span className="verify-count-badge">{newValues.length}</span>
                        Payment{newValues.length > 1 ? 's' : ''} selected
                    </span>
                    <button className="verify-btn" onClick={handleVerifyPayments}>
                        Verify {newValues.length > 1 ? 'Payments' : 'Payment'}
                    </button>
                    <button className="verify-clear-btn" onClick={() => { setSelectedItems([]); setNewValues([]); }}>
                        Cancel
                    </button>
                </div>
            )}
        </div>
    );
};

export default AllPaymentsV2;